module.exports = "<p>\n  create-group works!\n</p>\n"